import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import {
  AvatarComponent,
  BadgeComponent,
  BreadcrumbRouterComponent,
  ColorModeService,
  ContainerComponent,
  DropdownComponent,
  DropdownDividerDirective,
  DropdownHeaderDirective,
  DropdownItemDirective,
  DropdownMenuDirective,
  DropdownToggleDirective,
  HeaderComponent,
  HeaderNavComponent,
  HeaderTogglerDirective,
  NavItemComponent,
  NavLinkDirective,
  ProgressBarDirective,
  ProgressComponent,
  SidebarToggleDirective,
  TextColorDirective,
  ThemeDirective,
} from '@coreui/angular';

import { IconDirective } from '@coreui/icons-angular';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { DataService } from '../../../services/data.service';

@Component({
    selector: 'app-default-header',
    templateUrl: './default-header.component.html',
    imports: [
        ContainerComponent,
        HeaderTogglerDirective,
        SidebarToggleDirective,
        IconDirective,
        HeaderNavComponent,
        NavItemComponent,
        NavLinkDirective,
        RouterLink,
        RouterLinkActive,
        NgTemplateOutlet,
        BreadcrumbRouterComponent,
        ThemeDirective,
        DropdownComponent,
        DropdownToggleDirective,
        TextColorDirective,
        AvatarComponent,
        DropdownMenuDirective,
        DropdownHeaderDirective,
        DropdownItemDirective,
        BadgeComponent,
        DropdownDividerDirective,
        ProgressBarDirective,
        ProgressComponent,
        NgStyle,
    ]
})
export class DefaultHeaderComponent extends HeaderComponent {
  userName: string;
  subscription: Subscription;

  readonly #colorModeService = inject(ColorModeService);
  readonly colorMode = this.#colorModeService.colorMode;

  readonly colorModes = [
    { name: 'light', text: 'Light', icon: 'cilSun' },
    { name: 'dark', text: 'Dark', icon: 'cilMoon' },
    { name: 'auto', text: 'Auto', icon: 'cilContrast' },
  ];

  readonly icons = computed(() => {
    const currentMode = this.colorMode();
    return (
      this.colorModes.find((mode) => mode.name === currentMode)?.icon ??
      'cilSun'
    );
  });

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private router: Router
  ) {
    super();
    this.userName = `${authService.getUserData().firstName} ${authService.getUserData().lastName}`;
    this.subscription = new Subscription();
  }

  ngOnInit() {
    // this.subscription = this.dataService.currentUserName.subscribe(
    //   (message) => (this.userName = message)
    // );
  }

  sidebarId = input('sidebar1');

  onLogout() {
    this.authService.clearTokensAndUserData();
    this.router.navigate(['/signin']);
  }
}
